// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2a3d12aab40531874ba9124475580000ab4ed24a/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};